<form [formGroup]="dateForm">

  <div  fxLayout="row" [fxLayoutAlign]="center?'center center':'start center'" fxLayoutGap="20px">
  <mat-form-field appearance="outline" fxFlex="15">
    <mat-label>{{ "DAY" | translate }}</mat-label>
    <mat-select
      formControlName="day"
      name="day"
      (selectionChange)="setValidation()"
    >
      <mat-option *ngFor="let day of days" [value]="day">
        {{ day }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" fxFlex="15">
    <mat-label>{{ "MONTH" | translate }}</mat-label>
    <mat-select
      formControlName="month"
      name="month"
      (selectionChange)="setValidation()"
    >
      <mat-option *ngFor="let month of months" [value]="month">
        {{ month }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" fxFlex="15">
    <mat-label>{{ "YEAR" | translate }}</mat-label>
    <mat-select
      formControlName="year"
      name="year"
      (selectionChange)="setValidation()"
    >
      <mat-option *ngFor="let year of years" [value]="year">
        {{ year }}
      </mat-option>
    </mat-select>
  </mat-form-field>


  </div>

</form>
